import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TimesCircle } from 'styled-icons/fa-solid/TimesCircle';
import Body from './Body';

const ErrorIcon = styled(TimesCircle)`
  min-width: 22px;
`;

const ErrorBody = ({ msg }) => (
  <Body msg={msg}>
    <ErrorIcon size={22} title="close" />
  </Body>
);

ErrorBody.propTypes = {
  msg: PropTypes.string.isRequired
};

export default ErrorBody;
